<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <a
        :class="[
          'c-label',
          backgroundColorClass,
          notClosableClass,
        ]"
        @click="$emit('click', { itemValue, itemText })"
        v-bind="attrs"
        v-on="on"
      >
        <div class="d-flex align-center">
          <category-icon
            :categoryKey="icon ? icon : 'NONE'"
            :iconColor="iconColor"
            class="inline-block"
            :size="16"
            :width="16"
            :height="16"
          />
          <smart-icon
            :icon="icon"
            :iconColor="iconColor"
            :class="['inline-block', customClass]"
            :size="16"
            :width="16"
            :height="16"
          />
          <img
            v-if="imgIcon"
            :src="imgIcon"
            class="inline-block c-label__knowledge-avatar-img"
          />
          <i
            v-if="svgIcon && !icon"
            :class="['c-label__svgIcon', 'v-icon', 'patient-overview__icon', svgIcon, customClass]"
          ></i>
          <span :class="['c-label__label', 'text-label', textColorClass, customClass]">
            {{ itemText }}
          </span>
          <span :class="['c-label__label', 'text-label', textColorClass, 'ml-0']" v-if="exclamation">!</span>
          <smart-icon
            v-if="closable"
            icon="eva-close-circle"
            :iconColor="iconColor"
            class="inline-block c-label__close-icon"
            :size="16"
          />
      </div>
    </a>
    </template>
    <div>{{ name }}</div>
    <div>{{ readableDate }}</div>
  </v-tooltip>
</template>

<script>
import CategoryIcon from "./CategoryIcon";
import SmartIcon from "./SmartIcon";
import moment from "moment";

/**
 * Component IconLabel.vue
 *
 * @module IconLabel
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/IconLabel.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "IconLabel",
  components: { CategoryIcon, SmartIcon },
  data: function () {
    return {
      notClosableClass: !this.$props.closable ? "c-label__not-closable" : "",
      readableDate: null,
    };
  },
  mounted: function () {
    this.readableDate =
      this.$props.date && this.$props.date !== ""
        ? moment(this.$props.date).format("DD/MM/YY")
        : "";
  },
  props: {
    closable: {
      type: Boolean,
      default: () => false,
    },
    backgroundColorClass: {
      type: String,
      default: () => "bg-color-coro-lightgray",
    },
    textColorClass: {
      type: String,
    },
    iconColor: {
      type: String,
      default: () => "rgba(0, 0, 0, 0.87)",
    },
    itemText: {
      type: String,
    },
    itemValue: {},
    icon: {
      type: String,
    },
    date: {
      type: String,
    },
    name: {
      type: String,
    },
    svgIcon: {
      type: String
    },
    exclamation: {
      type: Boolean
    },
    imgIcon: {
      type: String
    },
    customClass: {
      type: String,
      default: ''
    }
  },
};
</script>

<style lang="scss">
// mobile first
.c-label {
  display: inline-block;
  margin: 6px 12px 6px 0;
  padding: 3px 5px 3px 11px;
  border-radius: 18px;
}

.c-label__label {
  margin-left: 5px;
  margin-right: 5px;
  display: inline-block;
}

.c-label__close-icon {
  line-height: 12px !important;
}

.c-label__not-closable {
  padding: 3px 11px !important;
}

.c-label-hover {
  position: absolute;
  top: 5px;
  left: 5px;
}

.c-label__svgIcon {
  background-size: contain !important;
  max-height: 17px;
  max-width: 17px;
  margin-right: 0;
  color: inherit;
}

.c-label__knowledge-avatar-img {
  width: 100%;
  max-width: 18px;
  border-radius: 50%;
}

.c-label .c-label__svgIcon.stats-row--green,
.c-label .inline-block.stats-row--green {
  color: #4caf4f;
  filter: invert(60%) sepia(48%) saturate(527%) hue-rotate(72deg) brightness(88%) contrast(90%);
}

.c-label .c-label__label.stats-row--green {
  color: #4caf4f;
}

.c-label .c-label__svgIcon.stats-row--red,
.c-label .inline-block.stats-row--red {
  color: #f44336;
  filter: invert(37%) sepia(92%) saturate(3960%) hue-rotate(344deg) brightness(106%) contrast(91%);
}

.c-label .c-label__label.stats-row--red {
  color: #f44336;
}

.c-label .c-label__svgIcon.stats-row--orange,
.c-label .inline-block.stats-row--orange {
  color: #ff9800;
  filter: invert(62%) sepia(98%) saturate(2167%) hue-rotate(359deg) brightness(101%) contrast(105%);
}

.c-label .c-label__label.stats-row--orange {
  color: #ff9800;
}

// mobile screens

// tablet screens

// desktop/large screens

// -------------------------------------------------- BEM modifiers ------------------------------------------------
</style>
